/**
 * Created by john on 8/24/15.
 */

'use strict';

/**
 * Provides a way to access the same context from different entry files and the nav bar.
 * Since the nav bar is a separate file than any of the other entries, we need to allow it
 * to reference the same context as the entry files so that they can communicate.
 * @returns {{getContext: Function, setContext: Function}}
 */
function contextProvider() {
    let _setContext;
    let _reject;
    let _timeout;

    /*  Create a promise and expose its methods so they can be called in the returned ContextProvider */
    let reset = () => {
        return new Promise((resolve, reject) => {
            _reject = reject;
            _setContext = ctx => {
                resolve(ctx);
                return ctx;
            };
        });
    };
    let _promise = reset();

    return {
        /**
         * Returns a promise that is resolved when setContext() is called with a context.
         * If the promise isn't resolved within 5 sec, rejects it.
         * @returns {Promise}
         */
        getContext: () => {
            if (!_timeout) {
                _timeout = setTimeout(() => {
                    _reject('Timed out waiting for context to be set.');
                }, 5000); // wait 5sec
            }

            return _promise.then(ctx => {
                // clear the timeout if this promise has already been resolved
                clearTimeout(_timeout);
                return ctx;
            });
        },

        /**
         * Sets the context that will be used to resolve the getContext() promise.
         * This should be called from an entry file if not using 'createEntryPointContext()'
         * @param context
         * @returns {FluxibleContext} The original context that was passed to the function.
         */
        setContext: context => {
            return _setContext(context);
        },

        /**
         * This should only get called for unit tests, to reset the state since this is a singleton
         * @private
         */
        _reset: () => {
            _promise = reset();
            clearTimeout(_timeout);
            _timeout = null;
        },
    };
}

module.exports = contextProvider();



// WEBPACK FOOTER //
// ./assets/js/global/reactHelpers/ContextProvider.es.js